import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

export function UpdatePatientInsuranceInformationFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.patientInsuranceInformationId"
        label="Patient Insurance Information ID"
        helperText="Enter the patient insurance information ID"
        placeholder="e.g. {{block.data.patientInsuranceInformationId}}"
      />
      <BlockValueTemplateField
        fieldName="config.planName"
        label="Plan Name"
        helperText="Enter the name of the insurance plan"
        placeholder="e.g. {{block.data.planName}}"
      />
    </Stack>
  );
}
